/**
 * Turn a tombstoned Gmail connection's `lastErrorReason` into what the user
 * should DO about it.
 *
 * The card used to say "Google revoked the previous token" for every tombstone,
 * which is the wrong instruction for the commoner cause: a grant that's missing
 * a scope Pixel needs. Reconnecting fixes both, but only one of them is the
 * user's own consent choice, and saying "revoked" sends them hunting for a
 * revocation that never happened.
 *
 * Any non-null reason means "needs reconnecting" — this only picks the wording.
 * Unknown / legacy values ('auth', written before the reasons were split) get
 * neutral copy rather than a guess.
 */
export function gmailReconnectMessage(reason: string | null): string {
  if (reason === 'auth_after_refresh') {
    return 'This account is missing a permission Pixel needs — reconnect and accept all the access it asks for.';
  }
  if (reason === 'invalid_grant') {
    return 'Google revoked the sign-in for this account — reconnect to keep sending from it.';
  }
  return 'This account stopped working — reconnect to keep sending from it.';
}
